import React from 'react';
import ReactDOM from 'react-dom/client';
import { BuildReviewPage } from './BuildReviewPage';
import { SafeBoundary } from '@/components/SafeBoundary';
import { initMonitoring } from '@/lib/monitoring';
import '../index.css';
import './tw-utilities.css';

initMonitoring('build-review');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SafeBoundary section="Build Review">
      <BuildReviewPage />
    </SafeBoundary>
  </React.StrictMode>
);
